<template>
    <transition name="notify">
        <div 
            class="notify" 
            v-if="show">
            <div class="notify__inner">
                <a 
                    @click="close" 
                    class="notify__close">
                    <i class="icon-close"/>    
                </a>
        
                <div class="notify__icon">
                    <i :class="iconClass"/>
                </div>
                <div class="notify__content">
                    <div class="notify__title">{{ title }}</div>
                    <p>{{ text }}</p>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
export default {
    props: {
        title: {
            type: String,
            default: '',
        },
        text: {
            type: String,
            default: '',
        },
        icon: {
            type: String,
            default: '',
        },
        hideAfter: {
            type: Number,
            default: null,
        },
        show: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        iconClass() {
            return `icon-${this.icon}`;
        }
    },
    watch: {
        show() {
            if(this.show && this.hideAfter) {
                clearTimeout(this.timer);
                this.timer = setTimeout(() => {
                    this.close();
                }, this.hideAfter);
            } else if(!this.show) {
                clearTimeout(this.timer);
            }
        }
    },
    methods: {
        close() {
            this.$emit('close');
        },
    },
    destroy() {
        clearTimeout(this.timer);
    }
};
</script>
